module.exports = __webpack_public_path__ + "img/hatching-chick.0d5491d6.png";